<template>
  <div class="order-common">
    <b-modal
      id="md-change-status"
      hide-footer
      title="Đổi trạng thái các đơn hàng:"
      no-close-on-backdrop
      size="xl"
    >
      <div class="flex-column">
        <b-row class="my-2">
          <b-col cols="4">
            <b-form-group
              label-cols-sm="4"
              label-cols-lg="4"
              label="Chọn trạng thái"
              label-class="font-weight-bold"
              class="mb-0 flex-column align-items-center"
            >
              <treeselect
                :options="optionStatus"
                :multiple="false"
                placeholder="Nhập trạng thái:"
                noResultsText="Không có kết quả"
                :match-keys="['label', 'custom']"
                v-model="statusParent"
                openDirection="bottom"
                :clearable="false"
                @select="onSelectStatus"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                >
                  <span :title="node.label"> {{ node.label }}</span>
                </label>
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col cols="4">
            <b-form-group
              label-cols-sm="4"
              label-cols-lg="4"
              label="Phân loại khách"
              label-class="font-weight-bold"
              class="mb-0"
              v-if="statusParent === ENUM.ORDER_STATUS.UN_SUCCESS"
            >
              <treeselect
                :options="optionCustomerClassification"
                :multiple="false"
                placeholder="Chọn phân loại:"
                noResultsText="Không có kết quả"
                :match-keys="['label', 'custom']"
                v-model="customerClassificationParent"
                openDirection="bottom"
                :clearable="false"
                @select="onSelectCustomerClassification"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                >
                  <span :title="node.label"> {{ node.label }}</span>
                </label>
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-2" v-if="showCancelReasonInput">
          <b-col cols="4">
            <b-form-group
              label-cols-sm="4"
              label-cols-lg="4"
              label="Lý do huỷ"
              label-class="font-weight-bold"
              class="mb-0"
            >
              <treeselect
                :key="`parent-cancel-${customerClassificationParent}`"
                :options="
                  getCancelStatusOptions({
                    toStatus: statusParent,
                    customerClassification: customerClassificationParent,
                  })
                "
                :multiple="false"
                placeholder="Nhập lý do:"
                noResultsText="Không có kết quả"
                :match-keys="['label', 'custom']"
                v-model="statusCancelParent"
                openDirection="bottom"
                :clearable="false"
                @select="onSelectCancelStatus"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                >
                  <span :title="node.label"> {{ node.label }}</span>
                </label>
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>

        <b-table
          class="table-common mt-4"
          hover
          bordered
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template #cell(statusValidate)="data">
            <div v-if="!data.item.onLoading" class="d-table-row">
              <div class="d-table-cell align-middle" style="width: 10%">
                <i
                  v-b-tooltip.hover
                  :title="htmlGetStatusValidate(data.item, 'title')"
                  :class="htmlGetStatusValidate(data.item, 'class')"
                ></i>
              </div>
              <div
                class="d-table-cell align-middle pb-1 pl-2"
                style="width: 90%"
              >
                {{ data.item.statusValidateName }}
              </div>
            </div>
            <div v-else>
              <b-spinner
                small
                label="Small Spinner"
                variant="primary"
                class="mr-1"
              ></b-spinner>
              <span class="text-primary">Đang xử lí...</span>
            </div>
          </template>
          <template #cell(storeId)="data">
            <span>
              {{ data.item.storeName }}
            </span>
          </template>
          <template #cell(status)="data">
            <b-form-group class="mb-0 d-flex align-items-center">
              <div class="d-table-row">
                <div class="d-table-cell align-middle" style="width: 30%">
                  <label class="font-weight-bold pt-1">
                    {{ data.item.statusName }}
                  </label>
                </div>
                <div class="d-table-cell align-middle" style="width: 10%">
                  <i
                    class="fa fa-arrow-right text-primary"
                    aria-hidden="true"
                  ></i>
                </div>
                <div class="d-table-cell align-middle mb-0" style="width: 65%">
                  <treeselect
                    :options="optionStatus"
                    :multiple="false"
                    placeholder="Chọn trạng thái"
                    noResultsText="Không có kết quả"
                    :match-keys="['label', 'custom']"
                    v-model="data.item.toStatus"
                    openDirection="bottom"
                    :clearable="false"
                    @select="onChangeStatus(data.item, $event)"
                    class="m-2"
                  >
                    <label
                      slot="option-label"
                      slot-scope="{ node, labelClassName }"
                      :class="labelClassName"
                    >
                      <span :title="node.label"> {{ node.label }}</span>
                    </label>
                  </treeselect>
                  <span
                    class="tree-select-custom"
                    v-if="data.item.toStatus === ENUM.ORDER_STATUS.UN_SUCCESS"
                  >
                    <treeselect
                      :options="optionCustomerClassification"
                      :multiple="false"
                      placeholder="Chọn phân loại khách"
                      noResultsText="Không có kết quả"
                      :match-keys="['label', 'custom']"
                      v-model="data.item.customerClassification"
                      openDirection="bottom"
                      :clearable="false"
                      @select="
                        onChangeCustomerClassification(data.item, $event)
                      "
                      class="m-2"
                    >
                      <label
                        slot="option-label"
                        slot-scope="{ node, labelClassName }"
                        :class="labelClassName"
                      >
                        <span :title="node.label"> {{ node.label }}</span>
                      </label>
                    </treeselect>
                  </span>
                  <span
                    class="mb-0"
                    v-if="htmlIsShown(data.item.toStatus, 'cancel-status')"
                  >
                    <treeselect
                      :key="`item-cancel-${data.item.id}-${data.item.customerClassification}`"
                      :options="getCancelStatusOptions(data.item)"
                      :multiple="false"
                      placeholder="Chọn lý do huỷ"
                      noResultsText="Không có kết quả"
                      :match-keys="['label', 'custom']"
                      v-model="data.item.cancelStatus"
                      openDirection="bottom"
                      :clearable="false"
                      class="m-2"
                    >
                      <label
                        slot="option-label"
                        slot-scope="{ node, labelClassName }"
                        :class="labelClassName"
                      >
                        <span :title="node.label"> {{ node.label }}</span>
                      </label>
                    </treeselect>
                  </span>
                </div>
              </div>
            </b-form-group>
          </template>
          <template #cell(actions)="row">
            <v-icon
              small
              class="text-danger"
              @click="onRemovedItem(row.item.id)"
              v-b-tooltip
              >mdi-delete</v-icon
            >
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          v-show="rows > perPage"
          aria-controls="my-table"
        ></b-pagination>
        <vcl-table
          v-if="onLoadingList"
          :speed="5"
          :animate="true"
          :columns="10"
          class="mb-4"
        ></vcl-table>
      </div>
      <b-overlay
        :show="onLoadingList || isBusy"
        rounded
        opacity="0.6"
        class="d-inline-block mr-3"
      >
        <template #overlay>
          <div class="d-flex align-items-center">
            <b-spinner variant="light" small type="grow"></b-spinner>
          </div>
        </template>
        <b-button
          variant="primary"
          size="sm"
          @click="onSaveOrderStatus"
          :disabled="!ableToSubmit"
        >
          <strong>Cập nhật</strong>
        </b-button>
      </b-overlay>

      <b-button
        style="width: 80px"
        variant="secondary"
        size="sm"
        @click="hideModalChangeStatus()"
      >
        <strong>Hủy</strong>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import linkMixin from '@/view/mixins/link.mixins.js';
import { validationMixin } from 'vuelidate';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { mapGetters } from 'vuex';
import { SET_ORDER_STATUS_SELECTED } from '@/core/services/store/modules/order/order-seleted-status.module.js';
import {
  CUSTOMER_CLASSIFICATION,
  ORDER_CANCEL_STATUS,
  ORDER_CANCEL_STATUS_CR,
  ORDER_CANCEL_STATUS_CUSTOMER_COME_TO_STORE,
  ORDER_CANCEL_STATUS_CUSTOMER_NOT_COME,
  ORDER_CANCEL_STATUS_DP,
  ORDER_CANCEL_STATUS_SHOP,
  ORDER_STATUS,
  ORDER_STATUS_CR,
  ORDER_STATUS_DP,
  ORDER_STATUS_SHOP,
  TIME_TRIGGER,
  TIMEOUT,
} from '@/utils/constants';
import {
  checkGroupOrderStatus,
  checkJobTitle,
  cloneDeep,
  filterByRoles,
  makeToastFaile,
  makeToastSuccess,
} from '@/utils/common';
import { VclTable } from 'vue-content-loading';
import { EventBus } from '@/core/services/event-bus';
import ENUM from '@/utils/enum';

const STATUS_VALIDATE = {
  INVALID: 0,
  VALID: 1,
  REQUIRED: 2,
};
const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};

export default {
  mixins: [validationMixin, apiCommonMixin, linkMixin],
  props: {
    userInfor: Object,
    param: Object,
    mode: String,
  },
  components: {
    Treeselect,
    VclTable,
  },
  data() {
    return {
      fields: [],
      ENUM,
      defaultFields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: {
            ...thStyleCommon,
            width: '5%',
          },
          formatter: (value) => {
            return `#${value}`;
          },
          tdClass: 'align-middle',
        },
        {
          key: 'storeId',
          label: 'Cửa hàng',
          thStyle: {
            ...thStyleCommon,
            width: '20%',
          },
          tdClass: 'text-center align-middle',
        },
        {
          key: 'status',
          label: 'Đổi trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '50%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'statusValidate',
          label: 'Kiểm tra',
          thStyle: {
            ...thStyleCommon,
            width: '28%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'align-middle',
        },
      ],
      items: [],
      itemsTerm: [],
      onLoadingList: false,
      isBusy: false,
      statusParent: null,
      statusCancelParent: null,
      customerClassificationParent: null,
      changingStatusStores: [],
      isSelectedStore: null,
      currentPage: 1,
      perPage: 10,
      optionStatus: [],
      optionCustomerClassification: [],
      optionCancelStatus: [],
    };
  },
  watch: {
    getOrderStatus: {
      handler(value) {
        this.itemsTerm = value;
      },
      deep: true,
    },
    $props: {
      handler() {
        switch (this.mode) {
          case 'changeStatus':
            this.selectedStatus = null;
            this.selectedCancelStatus = null;
            this.customerClassificationParent = null;
            break;
          default:
            break;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initConstants();
  },
  mounted() {
    EventBus.$on('popup-common-order', this.popupOrderCommon);
  },
  beforeDestroy() {
    EventBus.$off('popup-common-order', this.popupOrderCommon);
  },
  computed: {
    ...mapGetters(['getOrderStatus']),
    rows() {
      return this.items.length;
    },
    showCancelStatusSelection() {
      return this.htmlIsShown(this.statusParent, 'cancel-status');
    },
    showCancelReasonInput() {
      return this.showCancelStatusSelection;
    },
    ableToSubmit() {
      return this.items?.every(
        (item) => item.statusValidate === STATUS_VALIDATE.VALID,
      );
    },
  },
  methods: {
    transformToTreeselectOptions(items) {
      return items.reduce((result, element) => {
        if (element.value !== null) {
          result.push({
            id: Number(element.value),
            label: element.text,
            custom: element.text.toLowerCase().replace(/\s+/g, ''),
            customLabel: element.text,
            originalValue: element.value,
          });
        } else {
          result.push({
            id: -1,
            label: element.text,
            custom: element.text.toLowerCase(),
            customLabel: element.text,
            originalValue: null,
          });
        }
        return result;
      }, []);
    },
    initConstants() {
      const userInfor = this.userInfor;
      this.fields = this.defaultFields;

      let status = [];
      let cancelStatus = [];
      const jobTitleId = userInfor.jobTitleId;

      if (checkJobTitle().isCR(jobTitleId)) {
        status = ORDER_STATUS_CR;
        cancelStatus = ORDER_CANCEL_STATUS_CR;
      } else if (checkJobTitle().isShop(jobTitleId)) {
        status = ORDER_STATUS_SHOP;
        cancelStatus = ORDER_CANCEL_STATUS_SHOP;
      } else if (checkJobTitle().isDP(jobTitleId)) {
        status = ORDER_STATUS_DP;
        cancelStatus = ORDER_CANCEL_STATUS_DP;
      } else {
        status = ORDER_STATUS;
        cancelStatus = ORDER_CANCEL_STATUS;
      }

      this.optionStatus = this.transformToTreeselectOptions(status);
      this.optionCancelStatus = this.transformToTreeselectOptions(cancelStatus);
      this.optionCustomerClassification = this.transformToTreeselectOptions(
        CUSTOMER_CLASSIFICATION,
      );
    },

    htmlIsShown(value, name) {
      let check = false;
      switch (name) {
        case 'cancel-status': {
          const status = [
            ENUM.ORDER_STATUS.UN_SUCCESS,
            ENUM.ORDER_STATUS.SYSTEM_CANCEL,
            ENUM.ORDER_STATUS.CR_CANCEL,
          ];

          if (status.includes(value)) {
            check = true;
          }
          break;
        }
      }
      return check;
    },
    htmlRowClass(item, type) {
      if (!item || type !== 'row') return;

      if (this.userInfor.storeId !== item.storeId) {
        return 'table-danger';
      }
    },
    htmlGetStatusValidate(item, type) {
      let name = '';
      switch (item.statusValidate) {
        case STATUS_VALIDATE.VALID: {
          name =
            type === 'class' ? 'fas fa-check-circle text-success' : 'Hợp lệ';

          break;
        }
        case STATUS_VALIDATE.REQUIRED: {
          name =
            type === 'class'
              ? 'fas fa-check-circle text-warning'
              : 'Chưa chọn lí do';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
          break;
        }
      }
      return name;
    },
    getCancelStatusOptions(item) {
      return item.toStatus === ENUM.ORDER_STATUS.UN_SUCCESS &&
        item.customerClassification
        ? this.getCustomerCancelOptions(item.customerClassification)
        : this.optionCancelStatus;
    },
    onSelectStatus(node) {
      this.isSelectedStore = false;
      const statusChanged = node.id;

      this.resetParentClassifications({ statusId: statusChanged });

      this.items.forEach((item) => {
        this.updateItemStatus({
          item,
          statusNode: node,
          statusId: statusChanged,
        });
      });
    },

    onChangeStatus(storeSelected, event) {
      const params = {
        storeSelected,
        event,
        currentStatus: storeSelected.status,
        newStatus: event.id,
      };

      if (!this.isSelectedStore) {
        this.handleParentStatusChange(params);
      } else {
        this.handleSingleStatusChange(params);
      }
    },

    // Helper methods
    resetParentClassifications({ statusId }) {
      if (statusId !== ENUM.ORDER_STATUS.UN_SUCCESS) {
        this.customerClassificationParent = null;
      }
      this.statusCancelParent = null;
    },

    updateItemStatus({ item, statusNode, statusId }) {
      const [statusValidate, statusValidateName] = this.validationStoreStatus(
        item.status,
        statusId,
        item.id,
      );

      item.toStatus = statusNode.id;
      item.toStatusName = statusNode.label;
      item.statusValidate = statusValidate;
      item.statusValidateName = statusValidateName;

      this.resetItemClassifications({ item, statusId });
    },

    resetItemClassifications({ item, statusId }) {
      if (statusId !== ENUM.ORDER_STATUS.UN_SUCCESS) {
        this.$set(item, 'customerClassification', null);
        this.$set(item, 'customerClassificationName', null);
      }
      this.$set(item, 'cancelStatus', null);
      this.$set(item, 'cancelStatusName', null);
    },

    handleParentStatusChange({
      storeSelected,
      event,
      currentStatus,
      newStatus,
    }) {
      const targetStore = this.items.find(
        (store) => store.id === storeSelected.id,
      );

      if (targetStore) {
        this.updateStoreStatus({
          targetStore,
          storeSelected,
          event,
          currentStatus,
          newStatus,
        });
      }
    },

    handleSingleStatusChange({
      storeSelected,
      event,
      currentStatus,
      newStatus,
    }) {
      this.isSelectedStore = true;
      this.changingStatusStores.push(storeSelected);

      const targetStore = this.changingStatusStores.find(
        (store) => store.id === storeSelected.id,
      );

      if (targetStore) {
        this.updateStoreStatus({
          targetStore,
          storeSelected,
          event,
          currentStatus,
          newStatus,
        });
      }
    },

    updateStoreStatus({
      targetStore,
      storeSelected,
      event,
      currentStatus,
      newStatus,
    }) {
      let [statusValidate, statusValidateName] = this.validationStoreStatus(
        currentStatus,
        newStatus,
        targetStore.id,
      );

      targetStore.toStatus = event.id;
      targetStore.toStatusName = event.label;
      targetStore.statusValidate = statusValidate;
      targetStore.statusValidateName = statusValidateName;

      if (newStatus !== ENUM.ORDER_STATUS.UN_SUCCESS) {
        this.$set(storeSelected, 'customerClassification', null);
        this.$set(storeSelected, 'customerClassificationName', null);
      }

      this.$set(storeSelected, 'cancelStatus', null);
      this.$set(storeSelected, 'cancelStatusName', null);
    },

    validateBodyUpdate(orderId) {
      const order = this.itemsTerm.find((item) => item.id === orderId);
      if (!order) {
        return false;
      }
      if (!this.isValidImeiItems(order.orderItems)) {
        return {
          message: 'Chưa nhập IMEI sản phẩm',
          isValid: false,
        };
      }
      return { message: '', isValid: true };
    },

    isValidImeiItems(orderItems) {
      return orderItems.every((item) => {
        if (
          item.productType === ENUM.PRODUCT_TYPE.PRODUCT_IMEI &&
          !item.imeiCode
        ) {
          return false;
        }
        if (item.gifts && item.gifts.length > 0) {
          return item.gifts.every(
            (gift) =>
              gift.productType !== ENUM.PRODUCT_TYPE.PRODUCT_IMEI ||
              gift.imeiCode,
          );
        }
        if (item.attachs && item.attachs.length > 0) {
          return item.attachs.every(
            (attach) =>
              attach.productType !== ENUM.PRODUCT_TYPE.PRODUCT_IMEI ||
              attach.imeiCode,
          );
        }
        return true;
      });
    },

    getUniqueList(arr, key) {
      // NOTE: item in under function is store
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    hideModalChangeStatus() {
      this.$bvModal.hide('md-change-status');
      this.changingStatusStores = [];
      this.items = [];
      this.isSelectedStore = null;
    },
    validationStoreStatus(statusChild, statusChanged, orderId) {
      let statusValidate = STATUS_VALIDATE.VALID;
      let statusValidateName = 'Hợp lệ';

      if (statusChanged === -1) {
        statusValidate = STATUS_VALIDATE.INVALID;
        statusValidateName = 'Chưa chọn';
        return [statusValidate, statusValidateName];
      }

      if (statusChanged === ENUM.ORDER_STATUS.SUCCESS) {
        const { isValid, message } = this.validateBodyUpdate(orderId);
        if (!isValid) {
          statusValidate = STATUS_VALIDATE.INVALID;
          statusValidateName = message;
          return [statusValidate, statusValidateName];
        }
      }

      try {
        const changedGroup = checkGroupOrderStatus().getByGroup(statusChanged);
        const sourceGroup = checkGroupOrderStatus().getByGroup(statusChild);
        const checkStatus = checkGroupOrderStatus().valid(
          sourceGroup,
          changedGroup,
        );

        if (!checkStatus) {
          statusValidate = STATUS_VALIDATE.INVALID;
          statusValidateName = 'Không hợp lệ';
        }
      } catch (error) {
        makeToastFaile(error.message);
        statusValidate = STATUS_VALIDATE.INVALID;
        statusValidateName = error.message;
      }

      return [statusValidate, statusValidateName];
    },
    onSelectCancelStatus(node) {
      this.items.map((item) => {
        this.$set(item, 'cancelStatus', node.id);
        this.$set(item, 'cancelStatusName', node.label);
      });
    },
    onSelectCustomerClassification(node) {
      this.customerClassificationParent = node.id;
      this.statusCancelParent = null;

      // Update all items with new classification and reset cancel status
      this.items.forEach((item) => {
        this.$set(item, 'customerClassification', node.id);
        this.$set(item, 'customerClassificationName', node.label);
        this.$set(item, 'cancelStatus', null);
        this.$set(item, 'cancelStatusName', null);
      });
    },
    onChangeCustomerClassification(storeSelected, event) {
      const storeIndex = this.items.findIndex(
        (store) => store.id === storeSelected.id,
      );

      if (storeIndex !== -1) {
        this.$set(this.items[storeIndex], 'customerClassification', event.id);
        this.$set(
          this.items[storeIndex],
          'customerClassificationName',
          event.label,
        );
        this.$set(this.items[storeIndex], 'cancelStatus', null);
        this.$set(this.items[storeIndex], 'cancelStatusName', null);
      }
    },
    getCustomerCancelOptions(customerClassification) {
      let cancelOptions = [];
      const jobTitleId = this.userInfor.jobTitleId;
      const roleName = [];

      if (customerClassification) {
        if (
          customerClassification ===
          Number(ENUM.CUSTOMER_CLASSIFICATION_TYPE.NOT_COME)
        ) {
          // Khách không đến
          cancelOptions = ORDER_CANCEL_STATUS_CUSTOMER_NOT_COME;
        } else if (
          customerClassification ===
          Number(ENUM.CUSTOMER_CLASSIFICATION_TYPE.COME_TO_STORE)
        ) {
          // Khách đến CH
          cancelOptions = ORDER_CANCEL_STATUS_CUSTOMER_COME_TO_STORE;
        }
      }

      if (checkJobTitle().isCR(jobTitleId)) {
        roleName.push('CR');
      } else if (checkJobTitle().isShop(jobTitleId)) {
        roleName.push('SHOP');
      } else if (checkJobTitle().isDP(jobTitleId)) {
        roleName.push('DP');
      }

      if (roleName.length > 0) {
        cancelOptions = filterByRoles(cancelOptions, roleName);
        return this.transformToTreeselectOptions(cancelOptions);
      }

      return this.transformToTreeselectOptions(cancelOptions);
    },
    onRemovedItem(itemRemoveId) {
      const findIndexBy = (items, itemRemoveId) => {
        return items.findIndex((item) => item.id === itemRemoveId);
      };

      const index = findIndexBy(this.items, itemRemoveId);
      if (index > -1) {
        this.items.splice(index, 1);
        this.$store.dispatch(SET_ORDER_STATUS_SELECTED, this.items);
        EventBus.$emit('re-seletect-order', this.items);
      }
    },
    async onSaveOrderStatus() {
      if (this.isBusy) {
        return;
      }

      const isSelectedStore = this.isSelectedStore;
      const uniqueListStores = this.getUniqueList(
        this.changingStatusStores,
        'id',
      );
      const items = isSelectedStore
        ? cloneDeep(uniqueListStores)
        : cloneDeep(this.items);

      // Validate items
      const invalids = items.filter((item) => !item.statusValidate);
      if (invalids.length) {
        makeToastFaile(
          `Đơn hàng không hợp lệ ${invalids.map((item) => item.id).join(', ')}`,
        );
      }

      this.isBusy = true;
      const dataMessages = { success: [], failed: [] };
      const loadingTimeouts = [];

      try {
        for (const item of items) {
          const index = this.items.findIndex((e) => e.id === item.id);

          if (index > -1) {
            this.items[index].onLoading = true;
          }

          // Validate customer classification
          if (
            item.toStatus === ENUM.ORDER_STATUS.UN_SUCCESS &&
            !item.customerClassification
          ) {
            dataMessages.failed.push(item);
            if (index > -1) {
              this.items[index].onLoading = false;
              this.items[index].statusValidate = STATUS_VALIDATE.INVALID;
              this.items[
                index
              ].statusValidateName = `Vui lòng chọn phân loại khách hàng`;
            }
            continue;
          }

          const param = {
            id: item.id,
            status: item.toStatus,
            storeId: item.storeId,
            cancelStatus: item.cancelStatus,
            customerClassification: item.customerClassification,
          };

          const [status, message] = await ApiService.put(
            `/orders/status/`,
            param,
          )
            .then((response) => {
              const { status, message } = response.data;
              return [status, message];
            })
            .catch((err) => {
              this.$nprogress.done();
              if (!err.response) {
                // network error
                return [0, 'Lỗi mạng'];
              } else {
                const message = err.response.data.message;
                return [0, message];
              }
            });

          if (index > -1) {
            const timeoutId = setTimeout(() => {
              this.items[index].onLoading = false;
            }, TIMEOUT.ORDER_STATUS_CHANGE);
            loadingTimeouts.push(timeoutId);
          }

          if (index > -1) {
            if (status) {
              dataMessages.success.push(item);
              this.items[index].statusValidate = STATUS_VALIDATE.VALID;
              this.items[index].statusValidateName = 'Cập nhật thành công';
            } else {
              dataMessages.failed.push(item);
              this.items[index].statusValidate = STATUS_VALIDATE.INVALID;
              this.items[index].statusValidateName = message;
            }
          }
        }

        this.handleSaveResults(dataMessages, items, loadingTimeouts);
      } catch (error) {
        makeToastFaile('Có lỗi xảy ra khi cập nhật trạng thái đơn hàng');
      } finally {
        this.isBusy = false;
        this.resetStatusChangeState();
      }
    },

    handleSaveResults(dataMessages, items, loadingTimeouts) {
      const allSuccess = dataMessages.success.length === items.length;

      if (allSuccess) {
        loadingTimeouts.forEach(clearTimeout);
        setTimeout(() => {
          this.items = [];
          this.$store.dispatch(SET_ORDER_STATUS_SELECTED, this.items);
        }, TIMEOUT.ORDER_STATUS_CHANGE);

        makeToastSuccess('Cập nhật trạng thái đơn hàng thành công');
        this.$bvModal.hide('md-change-status');
        this.$emit('refresh', true);
      } else {
        const successCount = dataMessages.success.length;
        if (successCount > 0) {
          makeToastFaile(
            `Cập nhật thành công ${successCount}/${items.length} đơn hàng`,
          );
        } else {
          makeToastFaile('Đơn hàng cập nhật thất bại');
        }
      }
    },

    resetStatusChangeState() {
      this.changingStatusStores = [];
      this.isSelectedStore = null;
    },

    getOrderByIds(orders) {
      this.onLoadingList = true;
      this.items = [];
      const orderIds = orders.map((order) => order.id);

      ApiService.post(`/orders/status/ids`, {
        orderIds,
      })
        .then((response) => {
          const { data } = response.data;
          const { status, message } = response.data;

          if (status) {
            setTimeout(() => {
              this.items = data;
              this.onLoadingList = false;
            }, TIME_TRIGGER);
          } else {
            makeToastFaile(message);
            this.onLoadingList = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onLoadingList = false;
          this.$nprogress.done();
        });
    },
    popupOrderCommon() {
      if (!this.itemsTerm.length) {
        makeToastFaile('Vui lòng chọn lại đơn hàng');
        this.$store.dispatch(SET_ORDER_STATUS_SELECTED, this.items);
        EventBus.$emit('re-seletect-order', this.items);
        return;
      }

      this.$bvModal.show('md-change-status');

      this.statusParent = null;
      this.statusCancelParent = null;
      this.customerClassificationParent = null;
      this.getOrderByIds(this.itemsTerm);
    },
  },
};
</script>

<style scoped>
.table-common /deep/ .vue-treeselect__input-container {
  padding-top: 0px;
}
.table-common /deep/ .vue-treeselect__control {
  border-radius: none;
  border: none;
  height: 2.5rem;
}

.table-common /deep/ .vue-treeselect__input {
  font-size: 22px;
}
</style>
